// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-section {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.main-image-container {
  position: relative;
  background: #fff;
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 1.5rem;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-placeholder {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e0e0e0;
  border-radius: 8px;
  width: 100%;
  height: 450px;
  color: #666;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  border: 2px dashed #ccc;
  overflow: hidden;
}

.image-placeholder:hover {
  color: #f09502;
  border-color: #f09502;
  background: #f0f0f0;
}

.image-placeholder:hover .image-frame {
  border-color: #f09502;
}

.image-placeholder:hover .mountains {
  border-bottom-color: #f09502;
}

.image-placeholder:hover .mountains::before {
  border-bottom-color: #f09502;
}

.image-placeholder:hover .sun {
  background: #f09502;
}

/* Estilos cuando hay imagen */
.image-placeholder:has(.main-project-image) {
  background: transparent;
  border: 2px solid #f09502;
  border-style: solid;
}

.image-placeholder:has(.main-project-image):hover {
  border-color: #e08502;
  background: transparent;
}

/* Estilos para el contenedor de imagen */
.image-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.main-project-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 6px;
  transition: all 0.3s ease;
  position: absolute;
  top: 0;
  left: 0;
}

.main-project-image:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.image-icon {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.image-frame {
  width: 80px;
  height: 80px;
  border: 3px solid #666;
  border-radius: 8px;
  position: relative;
  background: transparent;
}

.mountains {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 25px solid #666;
}

.mountains::before {
  content: '';
  position: absolute;
  left: -15px;
  top: 0;
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 20px solid #666;
}

.sun {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 12px;
  height: 12px;
  background: #666;
  border-radius: 50%;
}

.plus-icon {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  background: #f09502;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
}

/* Botones de acción */
.action-buttons {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

.upload-new-btn,
.change-image-btn {
  background: #f09502;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.upload-new-btn:hover,
.change-image-btn:hover {
  background: #e08502;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.upload-new-btn i {
  font-size: 12px;
}

/* Botones sutiles izquierda arriba */
.image-actions-top-left {
  position: absolute;
  top: 15px;
  left: 15px;
  display: flex;
  gap: 8px;
  z-index: 20;
}

.action-icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.85);
  color: #333;
  border: 1px solid rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(4px);
}

.action-icon-btn:hover {
  background: #fff;
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.action-icon-btn.edit { color: #f09502; }
.action-icon-btn.delete { color: #dc3545; }

.status-badge {
  position: absolute;
  top: 54px;
  left: 102px;
  bottom: auto;
  z-index: 10;
}

.status-select {
  background: #f0618f; /* Rosa del diseño de Figma */
  border: none;
  border-radius: 40px;
  padding: 10px 24px;
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  outline: none;
  cursor: pointer;
  appearance: none;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.info-badges {
  position: absolute;
  top: 54px;
  right: 102px;
  display: flex;
  flex-direction: row;
  gap: 16px; /* Gap entre badges */
  z-index: 10;
}

.badge {
  background: #ffb366;
  color: white;
  border-radius: 8px;
  padding: 0.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
  max-width: 110px;
}

.badge i {
  font-size: 1.1rem;
  margin-bottom: 0.3rem;
}

.badge-label {
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 0.3rem;
}

.badge-value {
  background: transparent;
  border: none;
  color: white;
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
  width: 100%;
  outline: none;
}

.badge-value::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.property-features {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: space-between;
  background: transparent;
  padding: 3rem 0 1rem 0;
  margin-bottom: 1rem;
  align-items: flex-start;
}

@media (max-width: 768px) {
  .property-features {
    flex-wrap: wrap;
    gap: 0.8rem;
  }
  
  .feature-item {
    flex: 1 1 calc(50% - 0.4rem);
    min-width: 140px;
  }
}

.feature-item {
  flex: 1;
  display: flex;
  justify-content: center;
  position: relative;
}

.feature-box {
  background: #e9ecef;
  border-radius: 12px;
  padding: 0.75rem;
  width: 100%;
  min-height: 80px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 0.5rem;
  transition: all 0.2s ease;
}

.feature-box:hover {
  background: #e0e6ea;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.dark-grey-box {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 0.5rem;
  width: 90%;
  min-height: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 0.5rem;
}

.icon-above {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.add-button-item {
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.add-feature-btn {
  background: #f09502;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;
  margin-top: 1rem;
  height: 50px;
}

.add-feature-btn:hover {
  background: #e08502;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(240, 149, 2, 0.3);
}

.add-feature-btn i {
  font-size: 1rem;
}

.feature-icon {
  color: #f09502;
  font-size: 1.1rem;
}

.feature-label {
  font-size: 0.8rem;
  color: #333;
  text-align: center;
  font-weight: 600;
  margin: 0;
  margin-bottom: 0.3rem;
  text-transform: capitalize;
}

/* Estilos para inputs y checkboxes en los campos */
.feature-input {
  width: 100%;
  max-width: 60px;
  padding: 0.4rem 0.5rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.8rem;
  text-align: center;
  background: white;
  transition: all 0.2s ease;
}

.feature-input:focus {
  outline: none;
  border-color: #f09502;
  box-shadow: 0 0 0 2px rgba(240, 149, 2, 0.2);
  transform: scale(1.05);
}

.feature-input:hover {
  border-color: #f09502;
}

.checkbox-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  background: white;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  border: 1px solid #ddd;
  transition: all 0.2s ease;
}

.checkbox-container:hover {
  border-color: #f09502;
  background: #fff8f0;
}

.feature-checkbox {
  width: 18px;
  height: 18px;
  accent-color: #f09502;
  cursor: pointer;
}

.checkbox-label {
  font-size: 0.75rem;
  color: #333;
  margin: 0;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

/* Modal de selección de campos */
.field-selector-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.field-selector-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.field-selector-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
}

.field-selector-header h3 {
  margin: 0;
  color: #333;
  font-size: 1.2rem;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: #f0f0f0;
  color: #333;
}

.field-selector-body {
  padding: 1.5rem;
  max-height: 50vh;
  overflow-y: auto;
}

.available-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.field-option {
  display: flex;
  align-items: center;
  padding: 1rem;
  border: 2px solid #eee;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
}

.field-option:hover {
  border-color: #f09502;
  background: #fff8f0;
}

.field-option.selected {
  border-color: #f09502;
  background: #fff8f0;
}

.field-option.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.field-option-icon {
  font-size: 1.5rem;
  margin-right: 1rem;
  width: 30px;
  text-align: center;
}

.field-option-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.field-option-name {
  font-weight: 500;
  color: #333;
  font-size: 0.9rem;
}

.field-option-type {
  font-size: 0.8rem;
  color: #666;
}

.field-option-checkbox {
  margin-left: 1rem;
}

.field-option-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #f09502;
}

.field-selector-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1.5rem;
  border-top: 1px solid #eee;
  background: #f8f9fa;
}

.btn-secondary {
  padding: 0.75rem 1.5rem;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.btn-secondary:hover {
  background: #f8f9fa;
  border-color: #ccc;
}

.btn-primary {
  padding: 0.75rem 1.5rem;
  background: #f09502;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.btn-primary:hover {
  background: #e08502;
}

/* Mejoras adicionales para los campos */
.feature-item {
  transition: all 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-2px);
}

/* Estilos para campos vacíos */
.feature-input:placeholder-shown {
  background: #f8f9fa;
  color: #6c757d;
}

.feature-input:not(:placeholder-shown) {
  background: white;
  color: #333;
  font-weight: 500;
}

/* Animación para checkboxes */
.feature-checkbox:checked + .checkbox-label {
  color: #f09502;
  font-weight: 600;
}

/* Mejora del icono */
.feature-icon {
  font-size: 1.2rem;
  transition: all 0.2s ease;
}

.feature-item:hover .feature-icon {
  transform: scale(1.1);
}

`, "",{"version":3,"sources":["webpack://./src/app/components/new-proyect/new-project-hero/new-project-hero.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;;EAEE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,wBAAwB,cAAc,EAAE;AACxC,0BAA0B,cAAc,EAAE;;AAE1C;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB,EAAE,6BAA6B;EAClD,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,eAAe;EAGf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,qBAAqB;EAChC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;EAClB;AACF;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".hero-section {\n  background: #fff;\n  border-radius: 12px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.main-image-container {\n  position: relative;\n  background: #fff;\n  border-radius: 8px;\n  padding: 2rem;\n  margin-bottom: 1.5rem;\n  min-height: 500px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.image-placeholder {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #e0e0e0;\n  border-radius: 8px;\n  width: 100%;\n  height: 450px;\n  color: #666;\n  font-size: 1.1rem;\n  transition: all 0.3s ease;\n  border: 2px dashed #ccc;\n  overflow: hidden;\n}\n\n.image-placeholder:hover {\n  color: #f09502;\n  border-color: #f09502;\n  background: #f0f0f0;\n}\n\n.image-placeholder:hover .image-frame {\n  border-color: #f09502;\n}\n\n.image-placeholder:hover .mountains {\n  border-bottom-color: #f09502;\n}\n\n.image-placeholder:hover .mountains::before {\n  border-bottom-color: #f09502;\n}\n\n.image-placeholder:hover .sun {\n  background: #f09502;\n}\n\n/* Estilos cuando hay imagen */\n.image-placeholder:has(.main-project-image) {\n  background: transparent;\n  border: 2px solid #f09502;\n  border-style: solid;\n}\n\n.image-placeholder:has(.main-project-image):hover {\n  border-color: #e08502;\n  background: transparent;\n}\n\n/* Estilos para el contenedor de imagen */\n.image-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.main-project-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.main-project-image:hover {\n  transform: scale(1.02);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.image-icon {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.image-frame {\n  width: 80px;\n  height: 80px;\n  border: 3px solid #666;\n  border-radius: 8px;\n  position: relative;\n  background: transparent;\n}\n\n.mountains {\n  position: absolute;\n  bottom: 15px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n  border-bottom: 25px solid #666;\n}\n\n.mountains::before {\n  content: '';\n  position: absolute;\n  left: -15px;\n  top: 0;\n  width: 0;\n  height: 0;\n  border-left: 15px solid transparent;\n  border-right: 15px solid transparent;\n  border-bottom: 20px solid #666;\n}\n\n.sun {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  width: 12px;\n  height: 12px;\n  background: #666;\n  border-radius: 50%;\n}\n\n.plus-icon {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  width: 20px;\n  height: 20px;\n  background: #f09502;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n/* Botones de acción */\n.action-buttons {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n}\n\n.upload-new-btn,\n.change-image-btn {\n  background: #f09502;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.upload-new-btn:hover,\n.change-image-btn:hover {\n  background: #e08502;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.upload-new-btn i {\n  font-size: 12px;\n}\n\n/* Botones sutiles izquierda arriba */\n.image-actions-top-left {\n  position: absolute;\n  top: 15px;\n  left: 15px;\n  display: flex;\n  gap: 8px;\n  z-index: 20;\n}\n\n.action-icon-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.85);\n  color: #333;\n  border: 1px solid rgba(0,0,0,0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(4px);\n}\n\n.action-icon-btn:hover {\n  background: #fff;\n  transform: scale(1.1);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.action-icon-btn.edit { color: #f09502; }\n.action-icon-btn.delete { color: #dc3545; }\n\n.status-badge {\n  position: absolute;\n  top: 54px;\n  left: 102px;\n  bottom: auto;\n  z-index: 10;\n}\n\n.status-select {\n  background: #f0618f; /* Rosa del diseño de Figma */\n  border: none;\n  border-radius: 40px;\n  padding: 10px 24px;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #fff;\n  outline: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n}\n\n.info-badges {\n  position: absolute;\n  top: 54px;\n  right: 102px;\n  display: flex;\n  flex-direction: row;\n  gap: 16px; /* Gap entre badges */\n  z-index: 10;\n}\n\n.badge {\n  background: #ffb366;\n  color: white;\n  border-radius: 8px;\n  padding: 0.6rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 100px;\n  max-width: 110px;\n}\n\n.badge i {\n  font-size: 1.1rem;\n  margin-bottom: 0.3rem;\n}\n\n.badge-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-bottom: 0.3rem;\n}\n\n.badge-value {\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 1rem;\n  font-weight: 700;\n  text-align: center;\n  width: 100%;\n  outline: none;\n}\n\n.badge-value::placeholder {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.property-features {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: space-between;\n  background: transparent;\n  padding: 3rem 0 1rem 0;\n  margin-bottom: 1rem;\n  align-items: flex-start;\n}\n\n@media (max-width: 768px) {\n  .property-features {\n    flex-wrap: wrap;\n    gap: 0.8rem;\n  }\n  \n  .feature-item {\n    flex: 1 1 calc(50% - 0.4rem);\n    min-width: 140px;\n  }\n}\n\n.feature-item {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n\n.feature-box {\n  background: #e9ecef;\n  border-radius: 12px;\n  padding: 0.75rem;\n  width: 100%;\n  min-height: 80px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 0.5rem;\n  transition: all 0.2s ease;\n}\n\n.feature-box:hover {\n  background: #e0e6ea;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.dark-grey-box {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 0.5rem;\n  width: 90%;\n  min-height: 50px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 0.5rem;\n}\n\n.icon-above {\n  position: absolute;\n  top: -40px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: #ffffff;\n  border-radius: 50%;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.add-button-item {\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.add-feature-btn {\n  background: #f09502;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n  height: 50px;\n}\n\n.add-feature-btn:hover {\n  background: #e08502;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(240, 149, 2, 0.3);\n}\n\n.add-feature-btn i {\n  font-size: 1rem;\n}\n\n.feature-icon {\n  color: #f09502;\n  font-size: 1.1rem;\n}\n\n.feature-label {\n  font-size: 0.8rem;\n  color: #333;\n  text-align: center;\n  font-weight: 600;\n  margin: 0;\n  margin-bottom: 0.3rem;\n  text-transform: capitalize;\n}\n\n/* Estilos para inputs y checkboxes en los campos */\n.feature-input {\n  width: 100%;\n  max-width: 60px;\n  padding: 0.4rem 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  text-align: center;\n  background: white;\n  transition: all 0.2s ease;\n}\n\n.feature-input:focus {\n  outline: none;\n  border-color: #f09502;\n  box-shadow: 0 0 0 2px rgba(240, 149, 2, 0.2);\n  transform: scale(1.05);\n}\n\n.feature-input:hover {\n  border-color: #f09502;\n}\n\n.checkbox-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  background: white;\n  padding: 0.3rem 0.6rem;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n  transition: all 0.2s ease;\n}\n\n.checkbox-container:hover {\n  border-color: #f09502;\n  background: #fff8f0;\n}\n\n.feature-checkbox {\n  width: 18px;\n  height: 18px;\n  accent-color: #f09502;\n  cursor: pointer;\n}\n\n.checkbox-label {\n  font-size: 0.75rem;\n  color: #333;\n  margin: 0;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n}\n\n/* Modal de selección de campos */\n.field-selector-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.field-selector-content {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.field-selector-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  border-bottom: 1px solid #eee;\n  background: #f8f9fa;\n}\n\n.field-selector-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 1.2rem;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #666;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.close-btn:hover {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.field-selector-body {\n  padding: 1.5rem;\n  max-height: 50vh;\n  overflow-y: auto;\n}\n\n.available-fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.field-option {\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  border: 2px solid #eee;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.field-option:hover {\n  border-color: #f09502;\n  background: #fff8f0;\n}\n\n.field-option.selected {\n  border-color: #f09502;\n  background: #fff8f0;\n}\n\n.field-option.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.field-option-icon {\n  font-size: 1.5rem;\n  margin-right: 1rem;\n  width: 30px;\n  text-align: center;\n}\n\n.field-option-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.field-option-name {\n  font-weight: 500;\n  color: #333;\n  font-size: 0.9rem;\n}\n\n.field-option-type {\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.field-option-checkbox {\n  margin-left: 1rem;\n}\n\n.field-option-checkbox input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #f09502;\n}\n\n.field-selector-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  padding: 1.5rem;\n  border-top: 1px solid #eee;\n  background: #f8f9fa;\n}\n\n.btn-secondary {\n  padding: 0.75rem 1.5rem;\n  border: 1px solid #ddd;\n  background: white;\n  color: #666;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s ease;\n}\n\n.btn-secondary:hover {\n  background: #f8f9fa;\n  border-color: #ccc;\n}\n\n.btn-primary {\n  padding: 0.75rem 1.5rem;\n  background: #f09502;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s ease;\n}\n\n.btn-primary:hover {\n  background: #e08502;\n}\n\n/* Mejoras adicionales para los campos */\n.feature-item {\n  transition: all 0.3s ease;\n}\n\n.feature-item:hover {\n  transform: translateY(-2px);\n}\n\n/* Estilos para campos vacíos */\n.feature-input:placeholder-shown {\n  background: #f8f9fa;\n  color: #6c757d;\n}\n\n.feature-input:not(:placeholder-shown) {\n  background: white;\n  color: #333;\n  font-weight: 500;\n}\n\n/* Animación para checkboxes */\n.feature-checkbox:checked + .checkbox-label {\n  color: #f09502;\n  font-weight: 600;\n}\n\n/* Mejora del icono */\n.feature-icon {\n  font-size: 1.2rem;\n  transition: all 0.2s ease;\n}\n\n.feature-item:hover .feature-icon {\n  transform: scale(1.1);\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
